import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import { capitalize } from "../../shared/utils";

export default class AbstractShape extends AbstractProvidedClass {
    selected = false;
    isHovered = false;
    showFlash = false;

    constructor(provider, data, appearance, speciesIds, labels) {
        super(provider);

        this.notes = data.notes ?? '';
        this.speciesIds = speciesIds;
        this.appearance = appearance;
        this.appearance.setParent(this);
        this.labels = labels;
        this.labels.setParent(this);
    }

    addSpecies(species, silent = false) {
        if (!silent) {
            this.flash();
        }
        if (this.speciesIds.includes(species.id)) {
            return false;
        }
        this.speciesIds.push(species.id);
        this.speciesCollection.addObject(species.id, this);
        this.labels.addSpecies(species);
        return true;
    }

    removeSpecies(species) {
        this.speciesIds = this.speciesIds.filter(id => id != species.id);
        this.speciesCollection.removeObject(species.id, this);
        this.labels.removeSpecies(species);
    }

    flash() {
        this.showFlash = true;
        setTimeout(() => this.showFlash = false, 150);
        setTimeout(() => this.showFlash = true, 300);
        setTimeout(() => this.showFlash = false, 450);
        setTimeout(() => this.showFlash = true, 600);
        setTimeout(() => this.showFlash = false, 750);
    }

    display() {
        throw new Error('Abstract method not implemented.');
    }

    mouseOver() {
        throw new Error('Abstract method not implemented.');
    }

    drag(dx, dy) {
        this.move(dx, dy);
    }

    move(dx, dy) {
        throw new Error('Abstract method not implemented.');
    }

    setPosition(x, y) {
        throw new Error('Abstract method not implemented.');
    }

    select() {
        this.selected = true;
        this.row.select();
    }

    deselect() {
        this.selected = false;
        this.row.deselect();
    }

    hover() {
        this.isHovered = true;
    }

    unhover() {
        this.isHovered = false;
    }

    hovered() {
        throw new Error('Abstract method not implemented.');

    }

    surrounded() {
        throw new Error('Abstract method not implemented.');
    }

    export() {
        throw new Error('Abstract method not implemented.');
    }

    get name() {
        return this.labels.first ?? this.title;
    }

    get title() {
        return capitalize(this.type);
    }

    get secondaryName() {
        return this.labels.second ?? '';
    }
}
